"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    countryList: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/general/countries'];
    },
    checkoutAddress: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/address'];
    },
    checkoutCity: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/city'];
    },
    checkoutCountryCode: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/countryCode'];
    },
    checkoutPostalCountryCode: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/postalCountryCode'];
    },
    checkoutEmail: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/email'];
    },
    checkoutPhonePrefix: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/prefix'];
    },
    checkoutPhone: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/phone'];
    },
    checkoutZipCode: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/zipCode'];
    },
    checkoutPrimaryPaxId: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/primaryPaxId'];
    },
    checkoutTerms: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/terms'];
    },
    checkoutValidate: function (_state, _getters, _rootState, rootGetters) {
        return rootGetters['booking/checkout/validate'];
    }
};
//# sourceMappingURL=external_checkout.js.map